import TopicPage from '../components/TopicPage';

const sections = [
  {
    title: 'Machine Learning Foundations',
    icon: '📐',
    cards: [
      {
        icon: '📊',
        title: 'ML Fundamentals',
        level: 'beginner',
        description: 'Supervised, unsupervised, and reinforcement learning. Bias-variance tradeoff, overfitting, and evaluation metrics.',
        topics: ['Loss functions', 'Gradient descent', 'Cross-validation', 'Regularization'],
      },
      {
        icon: '🌳',
        title: 'Classical ML',
        level: 'beginner',
        description: 'Linear/logistic regression, decision trees, SVMs, random forests, and ensemble methods.',
        topics: ['Random Forest', 'XGBoost', 'SVM', 'Feature engineering'],
      },
      {
        icon: '📉',
        title: 'Model Evaluation',
        level: 'intermediate',
        description: 'Precision, recall, F1, ROC-AUC, confusion matrix, and hyperparameter tuning strategies.',
        topics: ['ROC-AUC', 'F1 score', 'GridSearchCV', 'A/B testing'],
      },
    ],
  },
  {
    title: 'Deep Learning',
    icon: '🧠',
    cards: [
      {
        icon: '🔗',
        title: 'Neural Networks',
        level: 'intermediate',
        description: 'Feedforward networks, backpropagation, activation functions, batch normalization, and dropout.',
        topics: ['Backprop', 'ReLU', 'BatchNorm', 'Dropout'],
      },
      {
        icon: '🖼️',
        title: 'CNNs',
        level: 'intermediate',
        description: 'Convolutional Neural Networks for image tasks. Convolution, pooling, ResNet, EfficientNet.',
        topics: ['Convolution', 'Pooling', 'ResNet', 'Transfer learning'],
      },
      {
        icon: '📝',
        title: 'RNNs & Transformers',
        level: 'advanced',
        description: 'Sequence models — LSTM, GRU, and the Transformer architecture (attention mechanism).',
        topics: ['LSTM', 'Self-attention', 'Positional encoding', 'BERT'],
      },
      {
        icon: '🔥',
        title: 'PyTorch / TensorFlow',
        level: 'intermediate',
        description: 'Deep learning frameworks. Dynamic graphs (PyTorch) vs static graphs (TF). Training loops and optimizers.',
        topics: ['Autograd', 'DataLoader', 'Keras', 'Adam optimizer'],
      },
    ],
  },
  {
    title: 'Large Language Models',
    icon: '💬',
    cards: [
      {
        icon: '🤖',
        title: 'LLM Fundamentals',
        level: 'intermediate',
        description: 'How LLMs work — pretraining, fine-tuning, RLHF, tokenization, and context windows.',
        topics: ['Tokenization', 'Pretraining', 'RLHF', 'Context window'],
      },
      {
        icon: '✍️',
        title: 'Prompt Engineering',
        level: 'beginner',
        description: 'Zero-shot, few-shot, chain-of-thought, and system prompts for reliable LLM outputs.',
        topics: ['Few-shot', 'CoT', 'System prompts', 'Structured output'],
      },
      {
        icon: '📚',
        title: 'RAG',
        level: 'intermediate',
        description: 'Retrieval-Augmented Generation — combine vector search with LLMs for knowledge-grounded answers.',
        topics: ['Embeddings', 'Vector DB', 'Chunking', 'Reranking'],
      },
      {
        icon: '🎯',
        title: 'Fine-tuning & PEFT',
        level: 'advanced',
        description: 'LoRA, QLoRA, and instruction fine-tuning to adapt LLMs to specific tasks cheaply.',
        topics: ['LoRA', 'QLoRA', 'SFT', 'PEFT library'],
      },
    ],
  },
  {
    title: 'MLOps',
    icon: '🔁',
    cards: [
      {
        icon: '📦',
        title: 'Model Serving',
        level: 'intermediate',
        description: 'Deploy models as REST APIs with FastAPI, TorchServe, TF Serving, or serverless inference.',
        topics: ['REST API', 'TorchServe', 'Triton', 'Batch inference'],
      },
      {
        icon: '🔍',
        title: 'Experiment Tracking',
        level: 'intermediate',
        description: 'MLflow, Weights & Biases for tracking runs, metrics, artifacts, and model registry.',
        topics: ['MLflow', 'W&B', 'Model registry', 'Artifact tracking'],
      },
      {
        icon: '📊',
        title: 'Model Monitoring',
        level: 'advanced',
        description: 'Detect data drift, concept drift, and model degradation in production with alerts.',
        topics: ['Data drift', 'Evidently', 'Alibi Detect', 'Retraining triggers'],
      },
    ],
  },
];

function AI() {
  return (
    <TopicPage
      title="AI / Machine Learning"
      subtitle="From classical ML to LLMs — build, train, and deploy intelligent systems."
      icon="🤖"
      color="#8b5cf6"
      sections={sections}
    />
  );
}

export default AI;
